module.exports = __webpack_public_path__ + "static/media/postipoiss.6e7ad921.svg";